var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apexchart',{staticClass:"sparkline-chart",staticStyle:{"display":"inline-block"},attrs:{"type":_vm.type,"height":_vm.height,"width":_vm.width,"options":_vm.sparkOptions,"series":_vm.data}})
}
var staticRenderFns = []

export { render, staticRenderFns }